// eslint-disable-next-line import/prefer-default-export
export function getEnvironment() {
  if (process.env.NODE_ENV === 'development') return 'Development'

  switch (window?.location?.host) {
    case 'dev.oktabletmenu.com':
    case 'v4-dev.oktabletmenu.com':
      return 'Alpha'
    case 'beta.oktabletmenu.com':
    case 'v4-beta.oktabletmenu.com':
      return 'Beta'
    case 'www.oktabletmenu.com':
    case 'oktabletmenu.com':
    case 'my.oktabletmenu.com':
      return 'Live'
    default:
      return 'Unknown'
  }
}
